<script>
    import { fade } from 'svelte/transition';
    import 'focus-visible';
    import BouncyBtn from './BouncyBtn.svelte'
    import GameScreen from './GameScreen.svelte'

    let started = false;

    var intro_audio = new Audio("/audio/intro2.mp3");
    intro_audio.volume = 0.4;

    const start_game = () => {
        started = true;
        intro_audio.play();
    }
</script>


<main>
    <GameScreen></GameScreen>
    {#if !started}
        <cover transition:fade>
            <main>
                <div class="bg"></div>
                <div class="bg bg2"></div>
                <div class="bg bg3"></div>
                <menu>
                    <img src="img/logo.png" alt="Stayin' Alive logo">
                    <BouncyBtn amount={20} duration={600} gluten menu on:click={start_game}>NEW GAME</BouncyBtn>
                    <sl-tooltip content="This feature is still under construction" placement="right">
                        <sl-button class="bouncy" size="large" disabled>LOAD GAME</sl-button>
                    </sl-tooltip>
                    <sl-tooltip content="This feature is still under construction" placement="right">
                        <sl-button class="bouncy" size="large" disabled>GUIDE & TIPS</sl-button>
                    </sl-tooltip>
                </menu>
            </main>
        </cover>
    {/if}
</main>

<style>
    cover {
        background-color: white;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
    }
	:global(body) {
		padding: 0;
		width: 100vw;
		height: 100vh;
		max-width:100%;
		overflow: hidden;
	}
	* {
		-webkit-touch-callout: none; /* iOS Safari */
		-webkit-user-select: none; /* Safari */
		-khtml-user-select: none; /* Konqueror HTML */
		-moz-user-select: none; /* Old versions of Firefox */
		-ms-user-select: none; /* Internet Explorer/Edge */
		user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
	}
	main {
		width: 100%;
		height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
	}
    menu {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        background-color: #c68a4f;
        border-radius: 1em;
        padding: 2em;
        box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
    }
    img {
        height: 30vh;
        margin-bottom: 3em;
    }
    .bouncy {
        --sl-input-font-family: "Gluten", sans-serif;
        letter-spacing: 2px;
        height: 70px;
        width: 250px;
        --sl-font-weight-semibold: 120;
        --sl-button-font-size-large: 2rem;
    }

    .bg {
        animation:slide 3s ease-in-out infinite alternate;
        background-image: linear-gradient(-60deg, #f0b20a 50%, #cc2c10 50%);
        bottom:0;
        left:-50%;
        opacity:.5;
        position:fixed;
        right:-50%;
        top:0;
        z-index:-1;
    }

    .bg2 {
        animation-direction:alternate-reverse;
        animation-duration:4s;
    }

    .bg3 {
        animation-duration:5s;
    }

    @keyframes slide {
        0% {
            transform:translateX(-25%);
        }
        100% {
            transform:translateX(25%);
        }
    }
</style>